import { ReactComponent as InfoIcon } from 'assets/information-circle.svg';
import { Button } from 'components';
import { useModifiedTranslation } from 'hooks/useModifiedTranslation';
import { useNavigate } from 'react-router-dom';

interface TradingAgreementNoticeProps {
    onOpenAgreementForm: () => void;
}

export const TradingAgreementNotice = ({ onOpenAgreementForm }: TradingAgreementNoticeProps) => {
    const { t } = useModifiedTranslation();
    const navigate = useNavigate();

    const handleFormButtonClick = () => {
        // Save to localStorage to mark agreement as completed (mock)
        localStorage.setItem('tradingAgreementCompleted', 'true');
        localStorage.setItem('tradingAgreementDate', new Date().toISOString());
        
        // Navigate to the form
        navigate('/form/Onboarding?contactId=60');
    };

    return (
        <div className='flex flex-col gap-4 p-4 bg-blue-50 rounded-lg border border-blue-200'>
            <div className='flex gap-3'>
                <div className='flex-1'>
                    <h3 className='flex mb-2 font-semibold text-gray-900'>
                        {t('tradingAgreement.notice.title')}
                        <InfoIcon className='flex-shrink-0 ml-1 w-6 h-6 text-blue-600' />
                    </h3>
                    <p className='text-sm text-gray-700'>
                        {t('tradingAgreement.notice.message')}
                    </p>
                </div>
            </div>
            <div>
                <Button onClick={handleFormButtonClick} variant='PPF' className='w-full'>
                    {t('tradingAgreement.notice.button')}
                </Button>
            </div>
        </div>
    );
};
